import { toastAlert } from '@/common/utils/Toast';

const sleep = (timeout) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(undefined), timeout);
  });

const updateToast = async (status, data) => {
  await sleep(500);

  if (status !== 200) {
    toastAlert(data.msg, 'error');
    return false;
  } else {
    toastAlert('수정되었습니다.', 'success');
    return true;
  }
};

const insertToast = async (status, data) => {
  await sleep(500);

  if (status !== 200) {
    toastAlert(data.msg, 'error');
    return false;
  } else {
    toastAlert('등록되었습니다.', 'success');
    return true;
  }
};
const removeToast = async (status, data) => {
  await sleep(500);

  if (status !== 200) {
    toastAlert(data.msg, 'error');
    return false;
  } else {
    toastAlert('삭제되었습니다.', 'success');
    return true;
  }
};
const customToast = async (status, data, message) => {
  await sleep(500);

  if (status !== 200) {
    toastAlert(data.msg, 'error');
    return false;
  } else {
    toastAlert(message, 'success');
    return true;
  }
};

export { updateToast, insertToast, removeToast, customToast };
